// 旅行社模块
import $http from '../../utils/http';
// let oldPath = 'tio/lxsdygl';
let travelPath = 'team-supervision-backend/api/travel'
const guidePath = 'team-supervision-backend/api/guide_backend'; // 导游的服务

export const travelList = data => {
  // 旅行社列表
  return $http({
    url: travelPath + '/travelAgency/page',
    data,
    method: 'POST'
  });
};

export const cityTree = data => {
  // 省市列表（树形）
  return $http({
    url: travelPath + '/travelAgency/region/tree',
    data,
    method: 'POST',
    isPayload: true
  });
};

export const getPendingList = params => {
  console.log('params = ', params)
  // 获取待办列表
  return $http({
    url: travelPath + '/home/travel/todoList',
    params
  });
};

export const getCity = data => {
  // 获取城市列表
  return $http({
    // url: travelPath + '/common/cityList',
    url: travelPath + '/pass/tio/cityList',
    data,
    method: 'POST'
  });
};

export const getTravelCityAll = data => {
  // 获取全部城市列表
  return $http({
    // url: travelPath + '/common/cityAllMessage',
    url: travelPath + '/pass/tio/cityAllMessage',
    data,
    method: 'POST'
  });
};

export const getTravelDetail = data => {
  // 获取旅行社详情
  return $http({
    // url: travelPath + '/travelAgency/message',
    // url: travelPath + '/travelAgency/findTravelById',
    url: travelPath + '/pass/tio/findTravelById',
    data,
    method: 'POST'
  });
};

export const getTravelPreviewList = data => {
  // 获取旅行社评论列表
  return $http({
    // url: travelPath + '/complainEvaluation/remark',
    url: travelPath + '/pass/tio/complainEvaluation/remark',
    data,
    method: 'POST'
  });
};

export const getCityAllNumber = params => {
  // 旅行社首页全部列表
  return $http({
    url: travelPath + '/home/travel/all/list',
    params
  });
};

export const getCityBlackNumber = params => {
  // 旅行社首页黑名单排名
  return $http({
    url: travelPath + '/home/travel/black/list',
    params
  });
};

export const getAllMonthNumber = params => {
  // 获取全部月份数量
  return $http({
    url: travelPath + '/home/travel/all/trend',
    params
  });
};

export const getBlackMonthNumber = params => {
  // 获取黑名单月份数量
  return $http({
    url: travelPath + '/home/travel/black/trend',
    params
  });
};

export const getHomeTravelNumber = params => {
  // 旅行社首页数据
  return $http({
    url: travelPath + '/home/travel/dashboard',
    params
  });
};

export const getNotDealList = params => {
  // 旅行社首页待办
  return $http({
    url: travelPath + '/home/travel/todo',
    params
  });
};

export const travelOnPass = data => {
  // 旅行社审核通过
  return $http({
    url: travelPath + '/travelAgency/auditYesTravel',
    data,
    method: 'POST'
  });
};

export const travelOnNoPass = data => {
  // 旅行社审核不通过
  return $http({
    url: travelPath + '/travelAgency/auditNoTravel',
    data,
    method: 'POST'
  });
};

export const travelBlackList = data => {
  // 旅行社黑名单列表
  return $http({
    url: travelPath + '/evaluation/api/travel/queryTravelBlackList',
    data,
    method: 'POST'
  });
};

export const travelBlackDetail = data => {
  // 旅行社黑名单列表
  return $http({
    url: travelPath + '/evaluation/api/travel/qryTravelEvaluationDetail',
    data,
    method: 'POST'
  });
};

export const traveltripList = data => {
  // 旅行社行程列表
  return $http({
    // url: travelPath + '/itineraray/queryItinerary',
    url: travelPath + '/pass/tio/itineraray/queryItinerary',
    data,
    method: 'POST'
  });
};

export const traveltripDetail = data => {
  // 旅行社行程单基本信息
  return $http({
    // url: travelPath + '/printSchedulec/findByIdItinerary',
    url: travelPath + '/pass/tio/findByIdItinerary',
    data,
    method: 'POST'
  });
};

export const tripCarList = data => {
  // 旅行社行程单基本信息
  return $http({
    // url: travelPath + '/printSchedulec/itineraryInfoCardList',
    url: travelPath + '/pass/tio/itineraryInfoCardList',
    data,
    method: 'POST'
  });
};

export const getTripList = data => {
  // 行程单行程
  return $http({
    // url: travelPath + '/printSchedulec/schedulePageList',
    url: travelPath + '/pass/tio/schedulePageList',
    data,
    method: 'POST'
  });
};

export const getTripPassengerList = data => {
  // 行程单游客
  return $http({
    // url: travelPath + '/printSchedulec/itineraryTouristList',
    url: travelPath + '/pass/tio/itineraryTouristList',
    data,
    method: 'POST'
  });
};

export const itineraryTravelList = data => {
  // 行程单 组团社信息 -- 委托设信息
  return $http({
    // url: travelPath + '/printSchedulec/itineraryTravelList',
    url: travelPath + '/pass/tio/itineraryTravelList',
    data,
    method: 'POST'
  });
};

export const getTripGuideList = data => {
  // 行程单导游
  return $http({
    // url: travelPath + '/printSchedulec/itineraryInfoGuideList',
    url: travelPath + '/pass/tio/itineraryInfoGuideList',
    data,
    method: 'POST'
  });
};

export const getBlackList = data => {
  // 旅行社黑名单监管信息
  return $http({
    // url: travelPath + '/evaluation/api/blacklist/travel/query',
    url: travelPath + '/pass/tio/blacklist/travel/query',
    data,
    method: 'POST'
  });
};

export const getDisciplineList = data => {
  // 旅行社惩戒信息
  return $http({
    // url: travelPath + '/evaluation/api/blacklist/travel/queryDiscipline',
    url: travelPath + '/pass/tio/blacklist/travel/queryDiscipline',
    data,
    method: 'POST'
  });
};

export const getSnnoList = data => {
  // 旅行社公告列表
  return $http({
    url: travelPath + '/evaluation/api/tsView/travel/noticeTIO',
    data,
    method: 'POST',
    isNotice: true
  });
};

export const getComplaintList = data => {
  // 旅社投诉信息
  return $http({
    url: travelPath + '/getComplaint',
    data,
    method: 'POST'
  });
};

export const getKeySupervisionList = params => {
  // 旅行社首页重点关注排名
  return $http({
    url: travelPath + '/home/travel/supervise/list',
    params
  });
};

export const getHomeMonthKeyList = params => {
  // 月度趋势（重点关注）
  return $http({
    url: travelPath + '/home/travel/supervise/trend',
    params
  });
};

export const getjurisdiction = ({ city, type }) => {
  const path = type === 'GUIDE' ? guidePath : travelPath
  // 地区权限
  return $http({
    url: path + '/evaluation/api/common/getUser',
    data: { city },
    method: 'POST'
  });
};

export const getTodoList = data => {
  // 旅行社代办列表
  return $http({
    url: travelPath + '/travelAgency/page',
    data,
    method: 'POST'
  });
};

export const getCreditIndexDeductionList = params => {
  // 诚信指数扣分列表
  return $http({
    url: travelPath + '/api/travel/deduct/page',
    params
  });
};

export const getGradeIndex = params => {
  // 诚信指数企业评分详情
  return $http({
    url: travelPath + '/api/travel/enterprise/grade',
    params
  });
};

export const getQualityIndexDeductionList = params => {
  // 诚信指数企业品质指数扣分列表
  return $http({
    url: travelPath + '/api/travel/enterprise/quality/page',
    params
  });
};

export const getSixMonthIntegrityList = params => {
  // 最近6个月诚信指数
  return $http({
    url: travelPath + '/api/travel/enterprise/quality/monthly6',
    params
  });
};

export const getGuideList = data => {
  // 旅行社签约导游列表
  return $http({
    // url: travelPath + '/guide/signingGuideList',
    url: travelPath + '/pass/tio/signingGuideList',
    data,
    method: 'POST'
  });
};

export const getMemberList = data => {
  // 旅行社公司职员列表
  return $http({
    // url: travelPath + '/travelAgencyPractitioners/page',
    url: travelPath + '/pass/tio/travelAgencyPractitioners/page',
    data,
    method: 'POST'
  });
};

export const getTreavelPhotoList = data => {
  // 旅行社证件照片
  return $http({
    url: travelPath + '/travelAgency/identificationPhoto',
    data,
    method: 'POST'
  });
};

export const getTreavelSuperviseDetail = params => {
  // 企业重点关注详情
  return $http({
    url: travelPath + '/api/travel/supervision/info',
    params
  });
};
export const auditNoTravel = data => {
  // 旅行社审核不通过
  return $http({
    url: travelPath + '/travelAgency/auditNoTravel',
    data,
    method: 'POST'
  });
};
export const auditYesTravel = data => {
  // 旅行社审核通过
  return $http({
    url: travelPath + '/travelAgency/auditYesTravel',
    data,
    method: 'POST'
  });
};

export const getApplyDetail = params => {
  // 获取单项委托详情
  return $http({
    url: travelPath + '/travelFunctionalApply/getApplyDetail',
    params
  });
};

export const getTravelApplyList = params => {
  // 单项委托审核记录
  return $http({
    url: travelPath + '/travelFunctionalApply/pageTravelApply',
    params
  });
};

export const travelApplyAudit = data => {
  // 单项委托审核
  return $http({
    url: travelPath + '/travelFunctionalApply/audit',
    data,
    method: 'POST'
  });
};

export default {
  travelList,
  cityTree,
  getCity,
  getTravelDetail,
  getTravelPreviewList,
  getCityAllNumber,
  getCityBlackNumber,
  getAllMonthNumber,
  getBlackMonthNumber,
  travelOnPass,
  travelOnNoPass,
  travelBlackList,
  travelBlackDetail,
  traveltripList,
  traveltripDetail,
  tripCarList,
  getTripList,
  getTripPassengerList,
  getTripGuideList,
  getHomeTravelNumber,
  getBlackList,
  getDisciplineList,
  getSnnoList,
  getComplaintList,
  getKeySupervisionList,
  getNotDealList,
  getHomeMonthKeyList,
  getjurisdiction,
  getTodoList,
  getCreditIndexDeductionList,
  getGradeIndex,
  getQualityIndexDeductionList,
  getGuideList,
  getMemberList,
  getSixMonthIntegrityList,
  getTravelCityAll,
  getTreavelPhotoList,
  getTreavelSuperviseDetail,
  auditNoTravel,
  auditYesTravel,
  itineraryTravelList,
  getPendingList,
  getApplyDetail,
  getTravelApplyList,
  travelApplyAudit

};
